module.exports = __webpack_public_path__ + "img/img11.1a0c97d9.jpg";